module.exports = __webpack_public_path__ + "img/9.d56b1296.png";